import { getImageQueryFragment, richTextFragment } from 'petdna-lib-uicomponents/hygraph';

const socialShareButtonFragment = `... on SocialShareButton {
  id
  name
  share
  shareEndpoint
  icon {
    ${getImageQueryFragment({})}
  }
  text {
    ${richTextFragment}
  }
}`;

const socialShareButtonListFragment = `... on SocialShareButtonList {
  id
  name
  shareButtons {
    ${socialShareButtonFragment}
  }
}`;

export const socialShareButtonListQuery = `query SocialShareButtonList($id: ID!) {
  socialShareButtonList(where: {id: $id}) {
    ${socialShareButtonListFragment}
  }
}`;
